// apps/web/src/components/landing-v2/proofs/NatalProof.tsx
/** Theme 02 / Natal chart — Cosmic-only. Conic-gradient wheel with a
 *  hollow center and three planet dots.  Reference: handoff .mm-natal. */
export function NatalProof() {
  return (
    <div className="absolute inset-0 flex items-center justify-center p-[18px]">
      <div
        className="relative aspect-square w-[62%] rounded-full border border-hairline-strong"
        style={{
          background:
            'conic-gradient(from 0deg, color-mix(in oklab, var(--color-astral-violet) 25%, transparent), color-mix(in oklab, var(--color-gold-light-legacy) 18%, transparent), color-mix(in oklab, var(--color-rose) 18%, transparent), color-mix(in oklab, var(--color-astral-violet) 25%, transparent), color-mix(in oklab, var(--color-gold-light-legacy) 18%, transparent), color-mix(in oklab, var(--color-astral-violet) 25%, transparent))',
          boxShadow: 'inset 0 0 30px rgba(0,0,0,0.5)' /* theme-audit: bespoke shadow */,
        }}
      >
        {/* Hollow centre */}
        <div
          className="absolute inset-[16%] rounded-full border border-hairline"
          style={{ background: 'var(--color-cosmic-black)' }}
        />
        {/* Centre glyph */}
        <div
          className="absolute inset-0 z-[2] flex items-center justify-center font-display"
          style={{
            color: 'var(--color-gold-light-legacy)',
            fontSize: '1.6rem',
          }}
        >
          ✦
        </div>
        {/* Planet markers */}
        <span
          className="absolute h-[10px] w-[10px] rounded-full"
          style={{
            top: '18%',
            left: '50%',
            background: 'var(--color-astral-violet-light)',
            boxShadow: '0 0 8px var(--color-astral-violet)',
          }}
        />
        <span
          className="absolute h-[10px] w-[10px] rounded-full"
          style={{
            top: '50%',
            right: '16%',
            background: 'var(--color-gold-light-legacy)',
            boxShadow: '0 0 8px var(--color-gold-light-legacy)',
          }}
        />
        <span
          className="absolute h-[10px] w-[10px] rounded-full"
          style={{
            bottom: '22%',
            left: '28%',
            background: 'var(--color-rose-light)',
            boxShadow: '0 0 8px var(--color-rose)',
          }}
        />
      </div>
    </div>
  )
}
